import React, { useEffect } from 'react';
import { QuestionnaireData } from '../../types';
import { StepId } from './steps';
import { stepComponents } from './stepComponents';
import { logger } from '../../utils/logger';

interface QuestionnaireStepProps {
  stepId: StepId;
  data: Partial<QuestionnaireData>;
  onChange: (data: Partial<QuestionnaireData>) => void;
}

export function QuestionnaireStep({
  stepId,
  data,
  onChange
}: QuestionnaireStepProps) {
  const StepComponent = stepComponents[stepId];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    logger.info(`Navigated to step: ${stepId}`);
  }, [stepId]);

  if (!StepComponent) {
    console.error(`No component found for step: ${stepId}`);
    return null;
  }

  return (
    <StepComponent
      data={data}
      onChange={onChange}
    />
  );
}